import { CLIENTS } from "../data/site";

export default function Marquee() {
  const loop = [...CLIENTS, ...CLIENTS];
  return (
    <div className="relative overflow-hidden py-10 border-y border-[#0b2e5e]/10">
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#FAF6EF] to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#FAF6EF] to-transparent z-10" />
      <div className="marquee-track">
        {loop.map((c, i) => (
          <span
            key={i}
            className="font-display text-3xl md:text-5xl text-[#0b2e5e]/40 hover:text-[#0b2e5e] transition-colors whitespace-nowrap"
          >
            {c}
            <span className="mx-8 text-[#FF3366]/60">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
